import { DocRenderer } from '@cyntler/react-doc-viewer';
import { ClickAwayListener } from '@mui/material';
import React, { useContext } from 'react';

import { ClickAwayContext } from './context';
import { PreviewControls } from './PreviewControls';

export const ImageRenderer: DocRenderer = ({ mainState }) => {
  const { onClickAway } = useContext(ClickAwayContext);
  const [zoom, setZoom] = React.useState(1);
  const handleZoomIn = () => {
    setZoom((prev) => prev + 0.1);
  };

  const handleZoomOut = () => {
    setZoom((prev) => prev - 0.1);
  };

  const memoizedStyle = React.useMemo(
    () => ({
      transform: `scale(${zoom})`,
    }),
    [zoom],
  );

  return (
    <div className="h-screen w-screen flex justify-center items-center">
      <PreviewControls
        onZoomIn={handleZoomIn}
        onZoomOut={handleZoomOut}
        resetZoom={() => {
          setZoom(1);
        }}
      />
      <ClickAwayListener onClickAway={onClickAway} touchEvent={false}>
        <img
          src={mainState.currentDocument?.uri}
          alt="file"
          className="object-contain w-1/2"
          style={memoizedStyle}
        />
      </ClickAwayListener>
    </div>
  );
};
ImageRenderer.fileTypes = [
  'image/png',
  'image/jpeg',
  'image/jpg',
  'image/gif',
  'image/webp',
  'webp',
];
ImageRenderer.weight = 1;
